import { useLocation } from "react-router";
import type { Exit } from "@/components/ui/box.schema";
import { inboxWords as words } from "./inbox-copy";

function useInboxBase(){
  const {pathname}=useLocation();
  return pathname.startsWith("/admin/teaching")?"/admin/teaching":pathname.startsWith("/student")?"/student":"/instructor";
}
/** The course's inbox, in the person's own shell: the way out of People's message box, said once (#1416). */
export function useCourseInboxExit(courseId:string):Exit {
  const base=useInboxBase();
  return {label:words.openInbox,to:`${base}/inbox?course=${encodeURIComponent(courseId)}`};
}
